<section class="db-edit-ecommerce-navigation-item-container">
  <div class="db-edit-ecommerce-navigation-item-header">
    <div>
      <span class="navigation-item-title mr8">
        {{ 'text_originalName' | dbText }} <span class="ml8" [innerHTML]="menuItem.title"></span>
      </span>
      <span class="navigation-item-type">
        {{types[menuItem.object_type]}}
      </span>
    </div>
    <div>
      <span class="navigation-item-delete"
            (click)="onDeleteItem()">
        {{'text_delete'|dbText}}
      </span>
      <span class="navigation-item-done"
            (click)="onSaveItem($event)">
        {{'text_done_short'|dbText}}
      </span>
    </div>
  </div>
  <div class="db-edit-ecommerce-navigation-item-body"
       [formGroup]="menuItemForm">
    <div class="navigation-item-field-container">
      <div class="required-field-label">
        <span>{{ 'text_navigationLabel' | dbText }}
          <span [class.invalid]="false"
                class="required-mark">
            *
          </span>
        </span>
      </div>
      <input class="ds-input"
             type="text"
             [ngClass]="{'error': menuItemForm.get('navigationLabel').invalid && menuItemForm.get('navigationLabel').touched}"
             formControlName="navigationLabel"
             [placeholder]="'text_exContactUs' | dbText">
      <div class="field-invalid-message"
           *ngIf="menuItemForm.get('navigationLabel').touched && menuItemForm.get('navigationLabel').invalid">
        {{ 'text_nameIsRequired' | dbText }}
      </div>
    </div>
    <div class="navigation-item-field-container" *ngIf="menuItem && menuItem.object_type === 'custom'">
      <div class="required-field-label">
        <span>
          {{ 'text_url' | dbText }}
          <span [class.invalid]="false"
                class="required-mark">
            *
          </span>
        </span>
      </div>
      <input class="ds-input"
             type="text"
             formControlName="url"
             [ngClass]="{'error': menuItemForm.get('url').invalid && menuItemForm.get('url').touched}"
             placeholder="www.example.com">
      <div class="field-invalid-message"
           *ngIf="menuItemForm.get('url').touched && menuItemForm.get('url').hasError('required')">
        {{ 'text_urlIsRequired' | dbText }}
      </div>
      <div class="field-invalid-message"
           *ngIf="menuItemForm.get('url').touched && menuItemForm.get('url').hasError('pattern')">
        {{ 'text_inputCorrectUrl' | dbText }}
      </div>
    </div>
  </div>
</section>
